import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import TimePicker from 'common/components/weekly-schedules/TimePairInput/TimePicker';
import { Typography as T } from 'common/typography';

import OpenCloseSwitch from './OpenCloseSwitch';
import { NormalOpeningHoursEntry } from './types';

type Props = {
  value: NormalOpeningHoursEntry;
  onChange: (newValue: NormalOpeningHoursEntry) => void;
};

const Root = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex: 1;
  min-height: 38px;
`;

const TimePickerContainer = styled.div`
  display: flex;
  align-items: center;
`;

const ToText = styled(T.Body3)`
  margin-inline-start: 8px;
  margin-inline-end: 8px;
  text-transform: uppercase;
`;

const StyledTimePicker = styled(TimePicker)`
  width: 117px;
`;

const NormalOpeningHoursEntryInput = ({ value, onChange }: Props) => {
  return (
    <Root>
      <OpenCloseSwitch
        isOpen={value.isOpen}
        onChange={() => {
          onChange({ from: 0, to: 0, isOpen: !value.isOpen });
        }}
      />

      {value.isOpen && (
        <TimePickerContainer>
          <StyledTimePicker
            value={value.from}
            onChange={from => {
              onChange({ ...value, from });
            }}
          />

          <ToText>
            <FormattedMessage id="venue-data-collection.venue-information-form.to" />
          </ToText>

          <StyledTimePicker
            value={value.to}
            onChange={to => {
              onChange({ ...value, to });
            }}
          />
        </TimePickerContainer>
      )}
    </Root>
  );
};

export default NormalOpeningHoursEntryInput;
